import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Label, Loader, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'
import { formatDate } from '../../utils/formats'

const VigenciaBandeira = (props) => (
  <CRUDIndex noTitle padded={false}
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell width={2}
            onClick={props.handleSort('starts_at')}
            sorted={props.handleSorted('starts_at')}>Início da Vigência</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('bandeira.nome')}
            sorted={props.handleSorted('bandeira.nome')}>Bandeira</Table.HeaderCell>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('bandeira.cor')}
            sorted={props.handleSorted('bandeira.cor')}>Cor</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='5'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleVigenciaBandeira.valueSeq().map((vigenciaBandeira, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/gestao_bandeiras/vigencias/${vigenciaBandeira.get('id')}`}>
                {vigenciaBandeira.get('id')}
              </Label>
            </Table.Cell>
            <Table.Cell>{formatDate(vigenciaBandeira.get('starts_at'))}</Table.Cell>
            <Table.Cell>{vigenciaBandeira.getIn(['bandeira', 'nome'])}</Table.Cell>
            <Table.Cell textAlign='center'>
              <Icon name='flag' size='big' style={{color: vigenciaBandeira.getIn(['bandeira', 'cor'])}} />
            </Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(vigenciaBandeira.get('id'))}
                onDeleteResource={() => props.onDeleteResource(vigenciaBandeira.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

VigenciaBandeira.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleVigenciaBandeira: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default VigenciaBandeira
